// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { GrayContainer } from '../../ui/containers';
import { Row, Column } from '../../ui/layout';
import { Label } from '../../ui/forms';
import KindBuildingSelect from './KindBuildingSelect';
import CitySelect from './CitySelect';
import SectorSelect from './SectorSelect';
import RoomsSelect from './RoomsSelect';
import SortSelect from './SortSelect';

const FiltersContainer = GrayContainer.extend`
  margin-top: 10px;
`;
class FiltersBar extends PureComponent {
  props: {
    query: Object,
    onChangeQuery: Function,
  }

  makeHandleChange = (name) =>
    (event) => {
      this.props.onChangeQuery({
        ...this.props.query,
        page: 0,
        [name]: event.target.value,
      });
    }

  render() {
    return (
      <FiltersContainer>
        <Row>
          <Column
            flex={1}
          >
            <Label>Inmueble:</Label>
            <KindBuildingSelect
              onChange={this.makeHandleChange('kindbuilding')}
              value={this.props.query.kindbuilding}
            />
          </Column>
          <Column
            flex={1}
          >
            <Label>En que ciudad?</Label>
            <CitySelect
              onChange={this.makeHandleChange('city')}
              value={this.props.query.city}
            />
          </Column>
          <Column
            flex={1}
          >
            <Label>Sector:</Label>
            <SectorSelect
              onChange={this.makeHandleChange('sector')}
              value={this.props.query.sector}
            />
          </Column>
          <Column
            flex={1}
          >
            <Label>Habitaciones:</Label>
            <RoomsSelect
              onChange={this.makeHandleChange('rooms')}
              value={this.props.query.rooms}
            />
          </Column>
          <Column
            flex={1}
          >
            <Label>Ordenar por:</Label>
            <SortSelect
              onChange={this.makeHandleChange('sort')}
              value={this.props.query.sort}
            />
          </Column>
        </Row>
      </FiltersContainer>
    );
  }
}

export default FiltersBar;



// WEBPACK FOOTER //
// ./src/components/BuildingsView/FiltersBar/index.js